export const SET_TAKE = 'SET_TAKE';

export const setTake = (take: number) => ({
  type: SET_TAKE,
  payload: take,
});
